"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("../../utils");
const PageTitle = ({ title, className }) => {
    return ((0, jsx_runtime_1.jsx)("h1", { className: (0, utils_1.cn)('text-2xl font-semibold mb-6 text-gray-900 dark:text-white', className), children: title }));
};
exports.PageTitle = PageTitle;
exports.PageTitle.displayName = 'PageTitle';
